const Loading = () => <div className='loader'></div>;

export default Loading;
